/**
 * Created by Florin David on 03/08/2020.
 */
import { v4 } from 'uuid'

let sessionId = sessionStorage.getItem('sessionId')

if (!sessionId) {
  sessionId = v4()
  sessionStorage.setItem('sessionId', sessionId)
}

/**
 * Get browser session id from local storage or create new one and save it if not found
 */
export default sessionId as string
